// switcher

import React from "react";
import styled, { css } from "styled-components";
import { useTheme } from "../context/ThemeContext";

const BREAKPOINT = "768px";

const ToggleContainer = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 100;

  /* Рразмеры */
  width: 60px;
  height: 34px;
  border-radius: 17px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);

  &:focus,
  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px var(--color-accent-green, rgba(5, 150, 105, 0.4));
  }

  display: none; /* Скрыт по умолчанию на мобильных */

  /* Показать на ПК */
  @media (min-width: ${BREAKPOINT}) {
    display: block;
  }

  /* Показать, если передан пропс для мобильного меню */
  ${(props) =>
    props.$isMobileMenu &&
    css`
      @media (max-width: ${BREAKPOINT}) {
        display: block;
      }
    `}

  /* АДАПТИВНОСТЬ: МОБИЛЬНЫЕ УСТРОЙСТВА (меньше 600px) */
  @media (max-width: 600px) {
    width: 55px;
    height: 30px;
    border-radius: 15px;
  }
`;

// backgr (day/night)
const Background = styled.div`
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  transition: background-image 0.5s ease-in-out, opacity 0.5s ease-in-out;
  ${(props) =>
    props.$theme === "light"
      ? css`
          background-image: url("./images/day-bg.png");
        `
      : css`
          background-image: url("./images/night-bg.png");
        `}
`;

// ползунок (шарик)
const Slider = styled.div`
  position: absolute;
  top: 3px;
  left: 3px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  transition: transform 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6); /* Эффект "пружины" */

  ${(props) =>
    props.$theme === "dark" &&
    css`
      /* Сдвиг: 60px (ширина) - 28px (размер) - 6px (отступы) = 26px */
      transform: translateX(26px);
    `}

  display: flex;
  align-items: center;
  justify-content: center;

  /* layout: phones */
  @media (max-width: 600px) {
    width: 24px;
    height: 24px;
    top: 3px;
    left: 3px;

    ${(props) =>
      props.$theme === "dark" &&
      css`
        /* Сдвиг на мобилке: 55px (ширина) - 24px (размер) - 6px (отступы) = 25px */
        transform: translateX(25px);
      `}
  }
`;

// moon
const MoonIcon = styled.div`
  width: 15px;
  height: 15px;
  border-radius: 50%;

  ${(props) =>
    props.$theme === "dark" &&
    css`
      background: transparent;
      box-shadow: inset -5px -2px 0 0 #f0f0f0;
      transform: rotate(-10deg);
    `}

  @media (max-width: 600px) {
    width: 12px;
    height: 12px;
  }
`;

export default function ThemeToggle({ $isMobileMenu = false }) {
  const { theme, toggleTheme } = useTheme();

  return (
    <ToggleContainer
      $isMobileMenu={$isMobileMenu}
      onClick={toggleTheme}
      aria-label={`Переключить на ${
        theme === "light" ? "тёмную" : "светлую"
      } тему`}
    >
      <Background $theme={theme} />

      <Slider $theme={theme}>
        {theme === "dark" && <MoonIcon $theme={theme} />}
      </Slider>
    </ToggleContainer>
  );
}
